<template>
  <el-dialog
    title="Execute"
    :visible.sync="isOpen"
    width="7.2rem"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
  >
    <div>
      <voteFromTo :title.sync="pageData.title" :desc.sync="pageData.desc" style="margin-bottom:0.3rem"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <loading-btn class="common-btn-blue-sm" label="Submit" @clickHandle="save" />
    </span>
  </el-dialog>
</template>

<script>
import { deepClone } from "@/utils/index.js";
import voteStatusComp from "@/views/governance/components/voteStatusComp.vue";
import voteFromTo from "@/views/governance/components/voteFromTo.vue"
export default {
  data() {
    return {
      isOpen: false,
      pageData: {},
    };
  },
  components: { voteStatusComp, voteFromTo },
  methods: {
    open({ row } = {}) {
      this.isOpen = true;
      this.pageData = deepClone(row);
      this.init();
    },
    close() {
      this.isOpen = false;
      this.pageData = {};
    },
    async init() {
      this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
      this.contractDaoAddress = this.$store.getters.contractMap["contractDao"].address;
    },
    getChangeName(type, proposal = []){
      let toItem = proposal[0] || {};
      let dataItem = this.$store.getters.proposalType.find(i => i.value == type) || {};
      let list = dataItem.children || [];
      let res = list.find(i => i.value == toItem.name);
      return res ? res.label : "";
    },
    save(btn) {
      const tx_builder = this.contractDao.methods["excuteProposal"](this.pageData.number);
      const encoded_tx = tx_builder.encodeABI();
      web3.eth
        .sendTransaction({
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractDaoAddress,
          value: 0,
          data: encoded_tx
        })
        .then(res => {
          btn.closeLoad();
          this.close();
          this.$emit("success");
          this.$message.success("operation successful!");
        })
        .catch(error => {
          if(error.code === 4001){
            this.$message.error("You have rejected this transaction");
          }else{
            this.$message.error("operation failed");
          }
          console.error(error);
          btn.closeLoad();
        });
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
.unit {
  font-size: 0.18rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
}
.big-num {
  font-size: 0.28rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #1f1f1f;
}
.detail-item{
  margin-bottom:0.32rem;
}

</style>
